import { render, staticRenderFns } from "./ActivityApply.vue?vue&type=template&id=b2d96f2e&scoped=true"
import script from "./ActivityApply.vue?vue&type=script&lang=js"
export * from "./ActivityApply.vue?vue&type=script&lang=js"
import style0 from "./ActivityApply.vue?vue&type=style&index=0&id=b2d96f2e&prod&lang=scss&scoped=true"
import style1 from "./ActivityApply.vue?vue&type=style&index=1&id=b2d96f2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d96f2e",
  null
  
)

export default component.exports